//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
import { random } from "lodash";
export default defineComponent({
  name: "ApplicationStandaloneLoader",
  props: {
    rows: {
      type: Number,
      default: 10
    }
  },
  setup() {
    const generateColumns = () => random(1, 3);
    const generateTitle = () => random(60, 90);
    return {
      generateColumns,
      generateTitle
    };
  }
});